/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ClasseHoraireCoherenceSearch,
  FcbClasseHoraireCoherenceGridDtoPaginatedResults,
  FilterCriteriaInfo,
  SelectItem,
} from '../models/index';
import {
    ClasseHoraireCoherenceSearchFromJSON,
    ClasseHoraireCoherenceSearchToJSON,
    FcbClasseHoraireCoherenceGridDtoPaginatedResultsFromJSON,
    FcbClasseHoraireCoherenceGridDtoPaginatedResultsToJSON,
    FilterCriteriaInfoFromJSON,
    FilterCriteriaInfoToJSON,
    SelectItemFromJSON,
    SelectItemToJSON,
} from '../models/index';

export interface ClasseHoraireCoherenceBaseSearchRequest {
    ClasseHoraireCoherenceSearch?: ClasseHoraireCoherenceSearch;
}

export interface ClasseHoraireCoherenceGetSearchCriteriasRequest {
    includeListsValues?: boolean;
}

export interface ClasseHoraireCoherenceGetSelectItemsRequest {
    searchField: string;
}

/**
 * 
 */
export class ClasseHoraireCoherenceApi extends runtime.BaseAPI {

    /**
     */
    async classeHoraireCoherenceBaseSearchRaw(requestParameters: ClasseHoraireCoherenceBaseSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FcbClasseHoraireCoherenceGridDtoPaginatedResults>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/ClasseHoraireCoherence/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClasseHoraireCoherenceSearchToJSON(requestParameters.ClasseHoraireCoherenceSearch),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FcbClasseHoraireCoherenceGridDtoPaginatedResultsFromJSON(jsonValue));
    }

    /**
     */
    async classeHoraireCoherenceBaseSearch(requestParameters: ClasseHoraireCoherenceBaseSearchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FcbClasseHoraireCoherenceGridDtoPaginatedResults> {
        const response = await this.classeHoraireCoherenceBaseSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async classeHoraireCoherenceGetSearchCriteriasRaw(requestParameters: ClasseHoraireCoherenceGetSearchCriteriasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FilterCriteriaInfo>>> {
        const queryParameters: any = {};

        if (requestParameters.includeListsValues !== undefined) {
            queryParameters['includeListsValues'] = requestParameters.includeListsValues;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/ClasseHoraireCoherence/criterias`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FilterCriteriaInfoFromJSON));
    }

    /**
     */
    async classeHoraireCoherenceGetSearchCriterias(requestParameters: ClasseHoraireCoherenceGetSearchCriteriasRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FilterCriteriaInfo>> {
        const response = await this.classeHoraireCoherenceGetSearchCriteriasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async classeHoraireCoherenceGetSelectItemsRaw(requestParameters: ClasseHoraireCoherenceGetSelectItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SelectItem>>> {
        if (requestParameters.searchField === null || requestParameters.searchField === undefined) {
            throw new runtime.RequiredError('searchField','Required parameter requestParameters.searchField was null or undefined when calling classeHoraireCoherenceGetSelectItems.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/ClasseHoraireCoherence/criteriaList/{searchField}`.replace(`{${"searchField"}}`, encodeURIComponent(String(requestParameters.searchField))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SelectItemFromJSON));
    }

    /**
     */
    async classeHoraireCoherenceGetSelectItems(requestParameters: ClasseHoraireCoherenceGetSelectItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SelectItem>> {
        const response = await this.classeHoraireCoherenceGetSelectItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
